<script lang="js" setup>
import { ref } from 'vue'
import StepCard from './StepCard.vue'

const steps = ref([
  {
    id: '01',
    title: 'Create a Poll',
    description: 'Easily define your question and options. Customize the poll to suit your needs, from simple to detailed.',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
  },
  {
    id: '02',
    title: 'Engage Your Team',
    description: 'Share the poll directly in Google Chat for quick participation, with no external apps required.',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0'
  },
  {
    id: '03',
    title: 'Track Results',
    description: 'Monitor real-time updates as votes come in, allowing for immediate insights and decision-making.',
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
  }
])
</script>

<template>
  <section id="how-it-works" class="py-10">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 max-w-[1141px]">
      <div class="flex flex-col gap-y-10 items-center justify-center">
        <!-- Header -->
        <div
          class="flex flex-col gap-y-4 items-center justify-center text-center"
        >
          <h2
            class="text-3xl sm:text-4xl lg:text-5xl font-bold font-poppins text-primary-dark uppercase"
          >
            Get Started in 3 Easy Steps
          </h2>
          <p class="text-base sm:text-lg text-primary-dark">
            From question to results in no time
          </p>
        </div>

        <!-- Mobile Layout -->
        <div class="flex flex-col gap-y-8 mt-6 sm:mt-8 lg:mt-10 xl:hidden">
          <div class="flex flex-col items-center gap-y-4 sm:gap-y-6">
            <StepCard :step="steps[0]" />
            <img
              src="@/assets/images/step1.png"
              alt="step 1"
              class="w-full sm:h-[250px] lg:h-[300px] aspect-auto"
            />
          </div>
          <div class="flex flex-col items-center gap-y-4 sm:gap-y-6">
            <StepCard :step="steps[1]" />
            <img
              src="@/assets/images/step2.png"
              alt="step 2"
              class="w-full sm:h-[250px] lg:h-[300px] aspect-auto"
            />
          </div>
          <div class="flex flex-col items-center gap-y-4 sm:gap-y-6">
            <StepCard :step="steps[2]" />
            <img
              src="@/assets/images/step3.png"
              alt="step 3"
              class="w-full sm:h-[250px] lg:h-[300px] aspect-auto"
            />
          </div>
        </div>

        <!-- Desktop Layout -->
        <div class="hidden xl:flex gap-x-10 mt-10">
          <div class="flex flex-col">
            <StepCard :step="steps[0]" />
            <img
              src="@/assets/images/step2.png"
              alt="step 2"
              class="h-[370px] aspect-auto mt-[120px] mb-[87px]"
            />
            <StepCard :step="steps[2]" />
          </div>
          <img
            src="@/assets/images/line.png"
            alt="vertical line"
            class="h-[1039px]"
          />
          <div class="flex flex-col">
            <img
              src="@/assets/images/step1.png"
              alt="step 1"
              class="h-[370px] aspect-auto"
            />
            <StepCard :step="steps[1]" class="mt-[95px] mb-[120px]" />
            <img
              src="@/assets/images/step3.png"
              alt="step 3"
              class="h-[370px] aspect-auto"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
